import React from "react";
import Navbar from "../Navbar/Navbar";

export default class Shell extends React.Component {
  location() {
    if (window.location.search.substr(1)) {
      return window.location.pathname + "?" + window.location.search.substr(1);
    }
    return window.location.pathname;
  }

  render() {
    return <Navbar {...this.props.data.navbar} />;
  }
}



// WEBPACK FOOTER //
// ./src/UI/Templates/Shell.js